//bfsg

import theme from 'theme'
import * as React from 'react'
import styled from 'styled-components'
import useLazyImgSrc from 'hooks/useLazyImgSrc'
import { ReactComponent as LinkArrow } from 'assets/link-arrow.svg'
import Link from 'theme/atoms/Link'
import { OptImg } from 'utils/imageOptimization'

type Props = {
  imgSrc: string | OptImg
  to: string
  name: string
  style?: 'logo' | 'noLogo'
  tracking?: () => void
}

export default function Teaser(props: Props) {
  const [ref, imgUrl] = useLazyImgSrc<HTMLImageElement>(props.imgSrc, 100)
  return (
    <Wrapper
      ref={ref}
      className="Teaser"
      $imgsrc={imgUrl}
      to={props.to}
      data-cy-handle="teaser-link"
      onClick={props.tracking ? props.tracking : null}
      title={props.name}
    >
      <div className="teaser-image"></div>
      <div className="teaser-description">
        <div className="teaser-description-headline">
          <span className="label" data-cy-handle="link">
            <div>{props.name}</div>
            <LinkArrow />
          </span>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled(Link)<{ $imgsrc: string }>`
  > .teaser-image {
    background-image: url('${(p) => p.$imgsrc}');
    display: block;
    background-size: cover;
    background-position: center center;
    height: 5.875rem;
    width: 8.875rem;
    @media (min-width: ${theme.ms.MD}px) {
      height: 7.1875rem;
      width: auto;
    }
    @media (min-width: ${theme.ms.LG}px) {
      height: 206px;
      width: auto;
    }
  }
  > .teaser-description {
    > .teaser-description-headline {
      padding-top: ${theme.spacing('xs')};
      display: flex;
      gap: ${theme.spacing('xs')};

      > .label {
        display: flex;
        gap: ${theme.spacing('xxs')};
        align-items: center;
        ${theme.ty('rc-s', 'bold', 'rc-base')};
      }
    }
    > div {
      > span {
        ${theme.ty('rc-s', 'bold', 'rc-base')};
        > svg {
          #Path-5,
          #Path-6 {
          }
          g {
            filter: none;
          }
        }
      }
    }
  }
`
